import { Card, Empty, List } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroll-component'

import { GroupAvatar } from '@/components'
import { useGetViewerCreatedGroupsQuery } from '@/generated/graphql'
import { UnArchiveGroup } from '@/modules/group/archive-group/unArchived-group.component'

import s from './archive.module.less'

export const ArchiveGroups = () => {
  const last = 20
  const { t } = useTranslation()
  const { data, loading, error, fetchMore } = useGetViewerCreatedGroupsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        last,
      },
      filter: {
        isArchived: true,
      },
    },
    notifyOnNetworkStatusChange: true,
  })

  if (error) {
    return null
  }

  const groups = (data ? data.viewer.groups.edges : [])
    .slice()
    .reverse()
    .map(({ node }) => node)
  const pageInfo = data
    ? data.viewer.groups.pageInfo
    : {
        startCursor: null,
        endCursor: null,
        hasPreviousPage: false,
        hasNextPage: false,
      }

  return (
    <div className={s.groupContainer}>
      <InfiniteScroll
        dataLength={groups.length}
        loader={null}
        hasMore={pageInfo.hasPreviousPage}
        next={() =>
          fetchMore({
            variables: {
              pagination: {
                last,
                before: pageInfo.startCursor,
              },
            },
          })
        }
      >
        <List
          dataSource={groups}
          loading={loading}
          renderItem={(group) => (
            <List.Item>
              <Card
                style={{ width: '100%' }}
                title={
                  <div style={{ fontSize: 16 }}>
                    <GroupAvatar groupCatId={group.category?.groupCategoryId} />
                    <span style={{ marginLeft: 16 }}>{group.name}</span>
                  </div>
                }
                extra={<UnArchiveGroup groupId={group.groupId} />}
              >
                {group.description ? (
                  <Card.Meta description={group.description} />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<span style={{ color: '#65676b' }}>{t('group.noDescription')}</span>}
                  />
                )}
              </Card>
            </List.Item>
          )}
        />
      </InfiniteScroll>
    </div>
  )
}
